export const styles = {
  container: "bg-white rounded-xl shadow-sm border overflow-visible w-full",
  tableWrapper: "relative overflow-x-auto overflow-visible",
  table: "min-w-full table-fixed border-separate border-spacing-0 rounded-xl overflow-hidden",
  theadRow: "bg-gray-50 text-gray-700 text-sm font-semibold border-b border-gray-200",
  th: "text-left px-5 py-3 whitespace-nowrap border-b border-gray-200",
  loaderRow: "border-b border-gray-200",
  loaderCell: "h-48 bg-white",
  loader: "flex justify-center items-center h-full",
  spinner: "animate-spin h-8 w-8 rounded-full border-2 border-gray-300 border-t-blue-500",
  emptyRow: "border-b border-gray-200",
  emptyCell: "h-48 bg-white",
  emptyWrapper: "flex justify-center items-center h-full",
  rowBase: "cursor-pointer border-b border-gray-200",
  rowExpanded: "bg-blue-50 hover:bg-blue-50",
  rowNormal: "hover:bg-gray-50",
  cellBase: "px-5 py-4 text-sm text-gray-800",
  chevronCell: "text-center w-[40px]",
  detailRow: "transition-all duration-300 border-b border-gray-200",
  detailExpanded: "max-h-[600px]",
  detailCollapsed: "max-h-0 overflow-hidden",
  detailWrapper: "bg-blue-50 border-b border-gray-200",
};
